<div *transloco="let t;" class="h-full relative flex ">
  <!-- BETA LOGO -->
  <!-- <div class="absolute top-0 left-0 z-20 pointer-events-none">
        <img class="w-32" src="./assets/img/Home/Label-Beta.png" />
    </div> -->
  <div class="flex relative w-full h-full">
    <k-side-menu [navigationList]="userNavigation" [userWallet]="userData.recordedWallet" (item)="onItemClick($event)"
      (onWalletClick)="copyToClipboard($event)" (onLogOutClick)="logOut()" (onPlayClick)="goToPlay($event)"
      (onWOKClick)="goToWOK($event)" (onNavigationItemClick)="$event.isMobile ? closeMenu() : null"></k-side-menu>
    <div class="w-full flex flex-col overflow-auto">
      <!-- OVERLAY TO CLOSE SIDE MENU -->
      <div *ngIf="!isMenuCollapsed"
        class="absolute bg-black bg-opacity-50 w-full h-full overlay md:hidden cursor-pointer " (click)="closeMenu()"
        style="z-index: 9;">
        <fa-icon class="absolute top-4 left-64" [icon]="'times'" size="2x"></fa-icon>
        <!-- <span class="absolute top-4 left-64">X</span> -->
      </div>
      <!-- TOP BAR -->
      <div class="nav-bar items-center justify-start sm:justify-end flex pl-5 flex-row-reverse sm:flex-row"
        [ngClass]="{'full-rounded':isMenuCollapsed}" click-out-directive (isClickOutside)='clickOutsideNavbar($event)'>
        <div class="flex mr-2 sm:mr-auto">
          <div *ngIf="hasEarlySupportBadge" class="badges-item mr-2 md:mr-6" [pTooltip]="'Early support badge'"
            tooltipPosition="bottom">
            <img class="" src="./assets/img/Icon/supporter.png" />
          </div>
          <div *ngIf="hasHunterBadge" class="badges-item mr-2 md:mr-6 cursor-pointer" (click)="getLink()"
            [pTooltip]="t('Hunter badge')" tooltipPosition="bottom">
            <img class="" src="./assets/img/Icon/hunter.png" />
          </div>
          <div *ngIf="hasCollectorBadge" class="badges-item mr-2 md:mr-6 cursor-pointer">
            <img class="" src="./assets/img/Icon/collector-badge.png" />
          </div>
          <notifications class=""></notifications>
        </div>
        <div id="balance-item-container" class="flex overflow-x-scroll mr-2 items-end h-full">
          <ng-container *ngFor="let item of balanceItems">
            <balances-item class="mr-3 self-center" [data]="item" [isFocus]="ingameItemFocus.get(item.key)"
              (onItemClick)="onBalanceItemClick($event)">
            </balances-item>
          </ng-container>
        </div>
        <div *ngIf="showQuickPurchase" id="quick-purchase-container" class="absolute" [style]="'top: 80px;'">
          <k-card-content>
            <div class="w-56 h-12 flex items-center ">
              <quick-purchase [data]="quickPurchaseItem" class="w-full"></quick-purchase>
            </div>
          </k-card-content>
        </div>
      </div>
      <div class="wok-banner flex flex-col md:flex-row items-center" *ngIf="showWokBanner">
        <div class="overlay"></div>
        <img src="./assets/img/Icon/wok-trainer-banner.png" class="trainer" />
        <img src="./assets/img/Icon/wok-logo.png" class="logo mr-0 md:mr-auto" />
        <span *ngIf="!isWhitelisted" class="text-center" [innerHTML]="t('banner.joinListing')"></span>
        <span *ngIf="isWhitelisted && trainerClubId==undefined" class="text-center"
          [innerHTML]="t('banner.congratsCheck')"></span>
        <span *ngIf="isWhitelisted && trainerClubId!==undefined" class="text-center"
          [innerHTML]="t('banner.congratsTrainer')"></span>
        <k-button size="sm" buttonStyle="gradient" [label]="'Whitelist Now!'" (click)="whitelistWok()"
          [isDisabled]="isWhitelisted" class="ml-0 mt-2 md:mt-0 md:ml-auto "></k-button>
        <img src="./assets/img/Icon/bushes.png" class="bushes" />
      </div>
      <!--<div class="banner-promo" [routerLink]="'/sale'">
        <span class="font-nikkyou"> 🎉 Baby Doge & Winter Sale is live!</span>
      </div>-->
      <div class="banner-migration">
        <p> Don't you see your assets, remember to migrate them to Polygon, switch to BNB Chain to start the migration</p>
          <k-button size="sm" buttonStyle="gradient" [label]="'Switch to BNB Chain'" (click)="switchtoBNB()"
          [isDisabled]="isWhitelisted" class="ml-0 mt-2 md:mt-0 md:ml-auto " *ngIf="showMigrationButton"></k-button>
      </div>
      <!-- PAGE CONTAINER -->
      <div class="w-full h-full overflow-y-auto page-container">
        <router-outlet *ngIf="true"></router-outlet>
      </div>
    </div>
  </div>
  <!-- <language-switch id="languageSwitchID" class="fixed z-20" [style]="isMenuCollapsed?'bottom: 14rem;':'bottom: 178px;'"></language-switch> -->
</div>
<p-toast key="session-expired" position="bottom-center" (onClose)="onSessionExpired()"></p-toast>